import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Loader from "./components/Loader";
import { useAuth } from "./Context/AuthContext"
import { Home } from "./pages/Home"; 
import Footer from "./components/footer"; 
import SigninPage from "./pages/signin";
import SignUp from "./components/signup/index";
import DashboardOverview from "./screens/Admin/DashboardOverview";
import "./scss/volt.scss";
import "react-datetime/css/react-datetime.css";
import Profile from "./screens/Profile";
import Users from "./screens/Admin/UsersScreen";
import RequestDoctorScreen from "./screens/RequestDoctor";
import RoomChange from "./screens/Room";
import OnlineCourses from "./screens/Courses";
import AddDoctor from "./components/AddDoctor";
import DoctorDetails from "./screens/DoctorDetails";
import CourseDetails from './screens/CourseDetails';
import CoursesScreen from "./screens/Admin/CoursesScreen";
import RoomsScreen from "./screens/Admin/RoomsScreen";
import AssignRolesScreen from "./screens/Admin/AssignRoleScreen";
import ManageTasksScreen from "./screens/Admin/ManageTasksScreen";
import Chat from "./screens/Chat";
import JobScreen from "./screens/Admin/JobScreen";
import Job from "./screens/Job";
import AssignRole from "./screens/AssignRole";
import UserAvailability from "./screens/UserAvailability";
import UsersAvailability from "./screens/Admin/UsersAvailabilityAdmin";
import ProtectedRoute from './components/ProtectedRoute';
import UserDashboard from "./screens/UserDashboard";
import Dashboard from "./screens/State/Dashboard";
//import AddShelter from "./screens/Admin/AddShelter";
import RefugeeDetails from "./screens/State/RefugeeDetails";
import NotificationDetails from './components/NotificationsDetails';
import Location from './components/Location';
import ForgotPassword from "./screens/ForgotPassword";
import UpdatePassword from "./screens/UpdatePassword";
import Activation from "./screens/Activation";
import RoomDetails from "./components/RoomDetails";
import CheckoutNotifications from "./components/CheckoutNotifications";
import Shelters from "./screens/State/Shelters";
import AllShelterLosses from "./screens/State/AllShelterLosses";
import AllAdmins from "./screens/State/AllAdmins";
import BestShelters from "./screens/State/BestShelters";
import AddShelterScreen from "./screens/Admin/AddShelterScreen";
import "@fortawesome/fontawesome-free/css/all.min.css";
import UpdateShelter from "./screens/Admin/updateshelter";
import RoomsP from "./screens/Admin/Romms";


function App() {
 const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1500);
  
    return () => clearTimeout(timeout);
  }, []);
  

  return (
    loading ? (
      <Loader />
    ) : (

    <Router>
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    <main style={{ flex: 1 }}>
      <Routes>
  {/* Public routes (no login required) */}
  <Route path="/" element={<Home />} />
  <Route path="/signin" element={<SigninPage />} />
  <Route path="/register" element={<SignUp />} />
  <Route path="/forget-psw" element={<ForgotPassword />} />
  <Route path="/updatepsw/:token" element={<UpdatePassword />} />
  <Route path="/verify/:activationCode" element={<Activation />} />

  {/* Protected routes (login required) */}
  <Route path="/profile" element={<ProtectedRoute element={<Profile />} />} />
  <Route path="/chat" element={<ProtectedRoute element={<Chat />} />} />
  <Route path="/doctor" element={<ProtectedRoute element={<AddDoctor />} />} />
  <Route path="/doctor/:id" element={<ProtectedRoute element={<DoctorDetails />} />} />
  <Route path="/courses" element={<ProtectedRoute element={<OnlineCourses />} />} />
  <Route path="/courses/:id" element={<ProtectedRoute element={<CourseDetails />} />} />
  <Route path="/request" element={<ProtectedRoute element={<RequestDoctorScreen />} />} />
  <Route path="/room" element={<ProtectedRoute element={<RoomChange />} />} />
  <Route path="/room-details/:id" element={<ProtectedRoute element={<RoomDetails />} />} />
  <Route path="/job" element={<ProtectedRoute element={<Job />} />} />
  <Route path="/availability" element={<ProtectedRoute element={<UserAvailability />} />} />
  <Route path="/task" element={<ProtectedRoute element={<AssignRole />} />} />
  <Route path="/dashboard" element={<ProtectedRoute element={<UserDashboard />} />} />
  <Route path="/location" element={<ProtectedRoute element={<Location />} />} />

  {/* Admin-only routes */}
  <Route path="/admin/dashboard" element={<ProtectedRoute element={<DashboardOverview />} adminOnly />} />
  <Route path="/admin/users" element={<ProtectedRoute element={<Users />} adminOnly />} />
  <Route path="/admin/rooms" element={<ProtectedRoute element={<RoomsScreen />} adminOnly />} />
  <Route path="/admin/courses" element={<ProtectedRoute element={<CoursesScreen />} adminOnly />} />
  <Route path="/admin/tasks" element={<ProtectedRoute element={<ManageTasksScreen />} adminOnly />} />
  <Route path="/admin/manage" element={<ProtectedRoute element={<AssignRolesScreen />} adminOnly />} />
  <Route path="/admin/jobs" element={<ProtectedRoute element={<JobScreen />} adminOnly />} />
  <Route path="/admin/availability" element={<ProtectedRoute element={<UsersAvailability />} adminOnly />} />
  <Route path="/admin/adduser" element={<ProtectedRoute element={<Users />} adminOnly />} />
  <Route path="/admin/addshelter" element={<ProtectedRoute element={<AddShelterScreen />} adminOnly />} />
  <Route path="/admin/updateshelter" element={<ProtectedRoute element={<UpdateShelter />} adminOnly />} />
  <Route path="/admin/rp" element={<ProtectedRoute element={<RoomsP />} adminOnly />} />
  <Route path="/admin/notification/:userId" element={<ProtectedRoute element={<CheckoutNotifications />} adminOnly />} />

  {/* State user routes */}
    <Route path="/state/dashboard"  element={<ProtectedRoute element={<Dashboard />} stateOnly />}/>
        <Route path="/state/all-shelter-losses"  element={<ProtectedRoute element={<AllShelterLosses />} stateOnly />}/>
        <Route path="/state/recommandation" element={<ProtectedRoute element={<BestShelters />} stateOnly />}/>
        <Route path="/state/shelters" element={<ProtectedRoute element={<Shelters />} stateOnly />}/>
  <Route path="/shelters/shelterdetails/:id" element={<ProtectedRoute element={<RefugeeDetails />} stateOnly/>} />
 <Route path="/state/admins"  element={<ProtectedRoute element={<AllAdmins />} stateOnly />}/>
  {/* Notification details (protected) */}
  <Route path="/notification/:notificationId" element={<ProtectedRoute element={<NotificationDetails />} />} />
</Routes>
      </main>
 
      </div>
    </Router>
    )
    
  );
}

export default App;
